var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-button',_vm._g(_vm._b({staticClass:"login-by-sso"},'app-button',{ ..._vm.$attrs },false),{ ..._vm.$listeners }),[_c('div',{staticClass:"login-by-sso-content"},[_c('app-load-icon',{attrs:{"icon-id":_vm.iconId}}),_c('span',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }